import styled from 'styled-components';

export const Container = styled.div`
  .header-top-mobile .banner-item-group.mobile,
  .header-top-mobile .timer-container,
  > .timer-container {
    display: none;
  }

  .header-top-mobile.fixed,
  .header-background-top.fixed {
    position: fixed;
    width: 100%;
    z-index: 999;
  }

  .header-background-top {
    background-color: var(--black);
  }

  .header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;

    .header-logo {
      max-width: 12rem;
    }

    .header-nav {
      display: flex;
      color: var(--white);
      font-size: 0.8rem;
      gap: 2rem;

      span {
        font-weight: 700;
      }

      .header-nav-location,
      .header-nav-user,
      .header-nav-shopping {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.4rem;
        cursor: pointer;
      }

      .header-nav-user {
        gap: 0.4rem;
      }

      .header-nav-user-info {
        display: flex;
        flex-direction: column;
      }

      .header-nav-shopping .icon {
        width: 1.8rem;
      }
    }
  }

  @media (max-width: 1450px) {
    .header-top .header-nav .header-nav-location {
      display: none;
    }
  }

  @media (max-width: 1200px) {
    .header-top-mobile .banner-item-group.mobile {
      display: flex;
      flex-direction: column;

      .banner-item {
        width: 100%;
      }
    }

    .banner-item-group.web {
      display: none;
    }

    > .header-background-top .header-top,
    .header-navigation-tree {
      display: none;
    }

    .header-mobile {
      display: flex;
    }

    .header-top {
      padding: 1rem 2rem;
    }
  }

  @media (max-width: 850px) {
    .header-logo {
      max-width: 10rem;
    }
  }

  @media (max-width: 768px) {
    .header-mobile .header-background-search {
      display: flex;
    }
  }

  @media (max-width: 470px) {
    .header-top .header-nav .header-nav-shopping .icon {
      width: 1.4rem;
    }
  }

  @media (max-width: 400px) {
    .header-logo {
      max-width: 8rem;
    }
  }

  @media (max-width: 360px) {
    .header-mobile .icon-menu-sandwich,
    .header-top .header-nav .header-nav-shopping .icon {
      width: 1.2rem;
    }

    .header-mobile
      .header-background-search
      .home-nav-location
      .home-nav-location-info
      span {
      font-size: 0.75rem;
    }

    .header-top .header-nav > span {
      font-size: 0.9rem;
    }
  }
`;
